// extracted by mini-css-extract-plugin
export var button = "index-module--button--5CF6U";
export var root = "index-module--root--7q7F+";